export default "__VITE_ASSET__bnJbP2Iv__"